import { Box, Button, Typography } from "@mui/material";
import SearchOffRoundedIcon from "@mui/icons-material/SearchOffRounded";
import { useNavigate } from "react-router-dom";
import { contentCardSx } from "./components/common/surfaceStyles";

export const NoPage = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ display: "flex", justifyContent: "center", px: 2, py: { xs: 4, md: 8 } }}>
      <Box sx={{ ...contentCardSx, width: "100%", maxWidth: 440, textAlign: "center" }}>
        <Box
          sx={{
            width: 56,
            height: 56,
            mx: "auto",
            mb: 2,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "rgba(25, 118, 210, 0.08)",
            color: "primary.main",
          }}
        >
          <SearchOffRoundedIcon />
        </Box>
        <Typography sx={{ fontSize: 40, fontWeight: 800, color: "#0f172a", lineHeight: 1 }}>404</Typography>
        <Typography sx={{ mt: 1, color: "text.secondary" }}>This page doesn't exist.</Typography>
        <Button
          variant="contained"
          onClick={() => navigate("/app/dashboard")}
          sx={{ mt: 3, textTransform: "none", fontWeight: 600, borderRadius: 2, boxShadow: "none", px: 3 }}
        >
          Go to Dashboard
        </Button>
      </Box>
    </Box>
  );
};
